import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';

// 引入自定义组件。index.js是组件的默认入口
import components from '@/components/index.js'
Vue.use(components);
Vue.use(ElementUI);
import router from './router'
import store from './store'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
